import React from 'react'

import { BlockMultimediaContent } from 'store/states/lessons.state'
import { ContentByType } from './ContentByType'

export interface MultimediaProps {
  data: BlockMultimediaContent
  courseId: number
}
const Multimedia: React.FC<MultimediaProps> = ({
  data: dataMultimedia,
  courseId,
}) => {
  return (
    <div>
      <ContentByType
        {...{
          dataMultimedia,
          courseId,
        }}
      />
    </div>
  )
}

export default Multimedia
